import { Grid } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { useCasoDetailGeneralInfo } from './hook';
import { CaseGeneralInfoProps } from './props';
import { Accordion } from '../../../../../components/general/accordion';
import FeedIcon from '@mui/icons-material/Feed';

export const CaseDetailGeneralInfo = ({
    casesGeneralInformation,
    account,
}: CaseGeneralInfoProps) => {
    const { formik } = useCasoDetailGeneralInfo(casesGeneralInformation);

    return (
        <Accordion
            title="INFORMACIÓN GENERAL"
            icon={<FeedIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={true}
            mt={0}
        >
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            >
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Call ID:"
                        name="callId"
                        size="small"
                        value={formik.values.callId}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Canal:"
                        name="channel"
                        size="small"
                        value={formik.values.channel}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Tipificación 1:"
                        name="typification1"
                        size="small"
                        value={formik.values.typification1}
                        disabled
                    />
                </Grid>
                {formik.values.typification2 && (
                    <Grid item xs={12} sm={6} md={4}>
                        <FieldText
                            label="Tipificación 2:"
                            name="typification2"
                            size="small"
                            value={formik.values.typification2}
                            disabled
                        />
                    </Grid>
                )}
                {formik.values.typification3 && (
                    <Grid item xs={12} sm={6} md={4}>
                        <FieldText
                            label="Tipificación 3:"
                            name="typification3"
                            size="small"
                            value={formik.values.typification3}
                            disabled
                        />
                    </Grid>
                )}
                {formik.values.typification4 && (
                    <Grid item xs={12} sm={6} md={4}>
                        <FieldText
                            label="Tipificación 4:"
                            name="typification4"
                            size="small"
                            value={formik.values.typification4}
                            disabled
                        />
                    </Grid>
                )}
                {formik.values.typification5 && (
                    <Grid item xs={12} sm={6} md={4}>
                        <FieldText
                            label="Tipificación 5:"
                            name="typification5"
                            size="small"
                            value={formik.values.typification5}
                            disabled
                        />
                    </Grid>
                )}
                {formik.values.document && (
                    <Grid item xs={12} sm={6} md={4}>
                        <FieldText
                            label="No. De documento:"
                            name="document"
                            size="small"
                            value={formik.values.document}
                            disabled
                        />
                    </Grid>
                )}
                {formik.values.vehiclePlate && (
                    <Grid item xs={12} sm={6} md={4}>
                        <FieldText
                            label="Placa del vehículo:"
                            name="vehiclePlate"
                            size="small"
                            value={formik.values.vehiclePlate}
                            disabled
                        />
                    </Grid>
                )}
                {formik.values.policyNumber && (
                    <Grid item xs={12} sm={6} md={4}>
                        <FieldText
                            label="No. De póliza:"
                            name="policyNumber"
                            size="small"
                            value={formik.values.policyNumber}
                            disabled
                        />
                    </Grid>
                )}
                {formik.values.branch && (
                    <Grid item xs={12} sm={6} md={4}>
                        <FieldText
                            label="Sucursal:"
                            name="branch"
                            size="small"
                            value={formik.values.branch}
                            disabled
                        />
                    </Grid>
                )}
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Observaciones:"
                        name="observation"
                        size="small"
                        value={formik.values.observation}
                        disabled
                    />
                </Grid>
                {account?.userAttendanceRequired && (
                    <>
                        <Grid item xs={12} sm={6} md={4}>
                            <FieldText
                                label="Identificación usuario asistencia"
                                name="userAttendanceId"
                                size="small"
                                disabled
                                value={formik.values.userAttendanceId}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                            <FieldText
                                label="Nombre/ razón social usuario asistencia"
                                name="userAttendanceName"
                                size="small"
                                disabled
                                value={formik.values.userAttendanceName}
                            />
                        </Grid>
                    </>
                )}
            </Grid>
        </Accordion>
    );
};
